import React from 'react';
import { Avatar, Toolbar, Typography, useMediaQuery } from '@mui/material';
import T from 'prop-types';
import { useTranslation } from 'react-i18next';

import { NotifyTypo } from 'web-components';
import { COLOR_PRIMARY } from 'attrs/colors';
import PageTitle from './PageTitle';
import SubNavigation from './SubNavigation';
import { ButtonWrapper, ContainerAvatar } from './elements';
import { AppBarContentWrapper, StyledAppBar } from '../../elements';
import ConnectedNavigationItems from './NavigationItems';
import LogoLink from './LogoLink';
import Alerts from './Alerts';
import ProductLauncher from './ProductLauncher';
import { getInitials } from '../../helpers/utils';

const Navbar = ({ routes, hasBack, user }) => {
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const { t } = useTranslation();

  const userFullName = `${user.first_name} ${user.last_name}`;
  const userPhoto = user?.photo;
  return (
    <StyledAppBar position="fixed">
      <Toolbar variant="dense" sx={{ height: '72px' }}>
        <ProductLauncher />
        <LogoLink hasBack={hasBack} />
        <AppBarContentWrapper>
          <PageTitle />
          <ConnectedNavigationItems routes={routes} />
        </AppBarContentWrapper>
        <ButtonWrapper>
          {isDesktop && userFullName && (
            <ContainerAvatar>
              <NotifyTypo.Heading2Regular style={{ fontSize: '1rem' }}>{t('hello')}</NotifyTypo.Heading2Regular>
              <Avatar
                key="userPhoto"
                alt={userFullName}
                src={userPhoto}
                sx={{
                  ml: 1,
                  display: { xs: 'none', md: 'flex' },
                  width: 24,
                  height: 24,
                  bgcolor: COLOR_PRIMARY,
                  color: '#FFFFFF',
                  mr: '70px'
                }}
              >
                <Typography sx={{ fontSize: 14, fontWeight: '550' }}>{getInitials(userFullName)}</Typography>
              </Avatar>
            </ContainerAvatar>
          )}
          <Alerts />
          <SubNavigation routes={routes} />
        </ButtonWrapper>
      </Toolbar>
    </StyledAppBar>
  );
};

Navbar.defaultProps = {
  hasBack: true
};

Navbar.propTypes = {
  routes: T.arrayOf(T.shape({})).isRequired,
  hasBack: T.bool,
  user: T.shape().isRequired
};

export default Navbar;
